import { Component, Input, OnChanges, OnDestroy } from '@angular/core';

import { BehaviorSubject ,  Observable ,  Subscription, timer } from 'rxjs';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-until-date',
    templateUrl: './until-date.component.html',
    // styleUrls: ['./until-date.component.scss']
})
export class UntilDateComponent implements OnChanges, OnDestroy {

    @Input() date: number; // milliseconds since the Unix Epoch, e.g. Date.now() or moment().valueOf()
    @Input() enable: boolean;

    days: number;
    hours: number;
    minutes: number;
    seconds: number;

    showSeconds: boolean;

    private minuteUnit = 60 * 1000;

    private timer$: BehaviorSubject<number> = new BehaviorSubject<number>(this.minuteUnit);

    private subscription = Subscription.EMPTY;

    ngOnChanges () {
        if (this.enable) {
            this.startTick();
        } else {
            this.stopTick();
        }
    }

    ngOnDestroy () {
        this.stopTick();
    }

    private startTick () {

        const diff = this.diff();

        this.stopTick();

        if (diff === 0) {
            this.seconds = 0;
            return;
        }

        // calculate immediately
        this.tick();

        // we need the period to vary based on how much time is remaining
        this.subscription = this.timer$.asObservable().pipe(
            distinctUntilChanged(),
            switchMap((period: number) => {
                // wipe out the milliseconds / seconds on each update
                const diff2 = this.diff();
                return timer(diff2 % period, period);
            })).subscribe(() => {
                this.tick();
            });
    }

    private stopTick () {
        this.subscription.unsubscribe();
    }

    private tick () {
        const diff = this.diff();

        // calculate values
        const days = diff / (1000 * 60 * 60 * 24);
        const hours = (days - Math.floor(days)) * 24;
        const minutes = (hours - Math.floor(hours)) * 60;
        const seconds = (minutes - Math.floor(minutes)) * 60;
        const milliseconds = (seconds - Math.floor(seconds)) * 1000;

        // output the floored values
        this.days = Math.floor(days);
        this.hours = Math.floor(hours);
        this.minutes = Math.floor(minutes);
        this.seconds = Math.floor(seconds);

        // by default we don't show the seconds
        this.showSeconds = false;

        // only show the seconds in the last minute
        if (this.days === 0 && this.hours === 0 && this.minutes === 0) {
            this.showSeconds = true;
        }

        // cancel the timer when we get to zero
        if (diff === 0) {
            this.stopTick();
            return;
        }

        // modify the timer period based on the time remaining
        if (days < 1 && hours < 1 && minutes < 2) {
            // switch to checking every second
            this.timer$.next(1000);
        }

    }

    private diff () {
        return Math.max((this.date || 0) - Date.now(), 0);
    }

}
